import type { State as UserInfoState } from './reducers/userInfoReducer';

export const userInfoSelector = (state: AppState): UserInfoState => state.userInfo;
